// Permission constants for better maintainability and autocomplete
export const PERMISSIONS = {
    // Insights
    SHOW_INSIGHT: 'show_insight',
    EXPORT_INSIGHT: 'export_insight',

    // Projects
    SHOW_PROJECT: 'show_project',
    ADD_PROJECT: 'add_project',
    DELETE_PROJECT: 'delete_project',
    UPDATE_PROJECT: 'update_project',

    // Units
    SHOW_UNIT: 'show_unit',
    ADD_UNIT: 'add_unit',
    DELETE_UNIT: 'delete_unit',
    UPDATE_UNIT: 'update_unit',
    ADD_CUSTOMER_UNIT: 'add_customer_unit',
    REMOVE_CUSTOMER_UNIT: 'remove_customer_unit',

    // Unit Updates
    SHOW_UNIT_UPDATES: 'show_unit_updates',
    ADD_UNIT_UPDATES: 'add_unit_updates',
    DELETE_UNIT_UPDATES: 'delete_unit_updates',
    UPDATE_UNIT_UPDATES: 'update_unit_updates',

    // Offers
    SHOW_OFFERS: 'show_offers',
    ADD_OFFERS: 'add_offers',
    DELETE_OFFERS: 'delete_offers',
    UPDATE_OFFERS: 'update_offers',
    SHOW_CUSTOMER_OFFER: 'show_customer_offer',

    // Tickets
    SHOW_TICKET: 'show_ticket',
    DELETE_TICKET: 'delete_ticket',
    CLOSE_TICKET: 'close_ticket',
    EXPORT_TICKET: 'export_ticket',

    // Categories
    SHOW_CATEGORY: 'show_category',
    ADD_CATEGORY: 'add_category',
    DELETE_CATEGORY: 'delete_category',
    UPDATE_CATEGORY: 'update_category',

    // Finance
    SHOW_FINANCE: 'show_finance',
    DELETE_FINANCE: 'delete_finance',
    CLOSE_FINANCE: 'close_finance',
    EXPORT_FINANCE: 'export_finance',
    UPDATE_INSTALLMENT: 'update_installment',

    // Customers
    SHOW_CUSTOMER: 'show_customer',
    ADD_CUSTOMER: 'add_customer',
    DELETE_CUSTOMER: 'delete_customer',
    UPDATE_CUSTOMER: 'update_customer',
    EXPORT_CUSTOMER: 'export_customer',

    // Groups
    SHOW_GROUP: 'show_group',
    ADD_GROUP: 'add_group',
    DELETE_GROUP: 'delete_group',
    UPDATE_GROUP: 'update_group',

    // Club
    SHOW_CLUB: 'show_club',
    ADD_CLUB: 'add_club',
    DELETE_CLUB: 'delete_club',
    UPDATE_CLUB: 'update_club',
    SHOW_CUSTOMER_CLUB: 'show_customer_club',

    // Swag Updates
    SHOW_SWAG_UPDATES: 'show_swag_updates',
    ADD_SWAG_UPDATES: 'add_swag_updates',
    DELETE_SWAG_UPDATES: 'delete_swag_updates',
    UPDATE_SWAG_UPDATES: 'update_swag_updates',

    // Logs
    SHOW_ADMIN_LOGS: 'show_admin_logs',
    SHOW_USER_LOGS: 'show_user_logs',

    // Notifications
    SHOW_NOTIFICATION: 'show_notification',

    // Admins
    SHOW_ADMINS: 'show_admins',
    CREATE_ADMINS: 'create_admins',
    UPDATE_ADMINS: 'update_admins',
    DELETE_ADMINS: 'delete_admins',
    UPDATE_PERMISSION: 'update_permission',
};

// Permission groups for common use cases
export const PERMISSION_GROUPS = {
    PROJECT_MANAGEMENT: [
        PERMISSIONS.SHOW_PROJECT,
        PERMISSIONS.ADD_PROJECT,
        PERMISSIONS.DELETE_PROJECT,
        PERMISSIONS.UPDATE_PROJECT,
    ],
    UNIT_MANAGEMENT: [
        PERMISSIONS.SHOW_UNIT,
        PERMISSIONS.ADD_UNIT,
        PERMISSIONS.DELETE_UNIT,
        PERMISSIONS.UPDATE_UNIT,
        PERMISSIONS.ADD_CUSTOMER_UNIT,
        PERMISSIONS.REMOVE_CUSTOMER_UNIT,
    ],
    CUSTOMER_MANAGEMENT: [
        PERMISSIONS.SHOW_CUSTOMER,
        PERMISSIONS.ADD_CUSTOMER,
        PERMISSIONS.DELETE_CUSTOMER,
        PERMISSIONS.UPDATE_CUSTOMER,
        PERMISSIONS.EXPORT_CUSTOMER,
    ],
    FINANCE_MANAGEMENT: [
        PERMISSIONS.SHOW_FINANCE,
        PERMISSIONS.DELETE_FINANCE,
        PERMISSIONS.CLOSE_FINANCE,
        PERMISSIONS.EXPORT_FINANCE,
        PERMISSIONS.UPDATE_INSTALLMENT,
    ],
    ADMIN_MANAGEMENT: [
        PERMISSIONS.SHOW_ADMINS,
        PERMISSIONS.CREATE_ADMINS,
        PERMISSIONS.UPDATE_ADMINS,
        PERMISSIONS.DELETE_ADMINS,
        PERMISSIONS.UPDATE_PERMISSION,
    ],
};

export default PERMISSIONS;
